import * as React from "react";
import { useField } from 'informed';
import * as classnames from 'classnames';
import '../components/Switch.css';
import { replaceDotsWithHyphens } from "../../misc/Helpers/StringHelper";

interface CheckboxProps {
    id: string;
    field: string;
    label: string;
    className?: string;
    disabled?: boolean;
    required?: boolean;
    onChange?: (boolean) => void;
    automationId?: string;
    labelSuffix?: () => React.JSX.Element
}

export const Checkbox = ({ id, field, label, disabled, required, onChange, automationId = null, labelSuffix = null }: CheckboxProps) => {
    const { fieldState, fieldApi } = useField<boolean>({ field: field });
    const { value } = fieldState;
    const { setValue } = fieldApi;

    const togglerClasses = classnames(
        'switch-toggle',
        `switch-toggle--${value ? 'on' : 'off'}`
    )

    return (
        <>
            <div 
                className="switch switch--small"
                aria-disabled={disabled} 
                onClick={() => {
                    if (disabled)
                        return;

                    if (onChange !== null && onChange !== undefined)
                        onChange(!value);

                    setValue(!value);
                }}>
                <div id={id} className={togglerClasses} data-automationid={automationId ?? replaceDotsWithHyphens(field)}></div>
                <label>{label}
                    {labelSuffix ? labelSuffix() : null}
                </label>
            </div>
        </>
    );
}
